/* eslint-disable react/prop-types */
/** @jsxImportSource @emotion/react */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CheckboxStyled } from '@nike/nike-design-system-components';

import { SELECT_ORDER } from './actions';
import { orderDetailsReportSelectors } from './reducer';

import { ORDERTYPE_STRING_MAP } from '../constants';

const OrdersTableRow = ({ order, targetRef, boxShadow }) => {
  const dispatch = useDispatch();

  const orderIdsSelectedMap = useSelector(orderDetailsReportSelectors.orderIdsSelectedMap);

  const orderId = order.id;

  return (
    <tr ref={targetRef} css={{ boxShadow }}>
      <td css={{ width: '68px' }}>
        <CheckboxStyled
          id={`${orderId}-checkbox`}
          checked={orderIdsSelectedMap[orderId]}
          onChange={e => dispatch({ type: SELECT_ORDER, payload: { id: orderId, checked: e.target.checked } })}
        />
      </td>
      <td css={{ color: 'black', fontWeight: '500' }}>{order.orderNumber}</td>
      <td>{order.departmentName}</td>
      <td>{ORDERTYPE_STRING_MAP[order.orderType]}</td>
      <td>{order.purchaseOrderRef}</td>
      <td>{order.customerRequestDate}</td>
      <td>{order.orderStatus}</td>
    </tr>
  );
};

export default OrdersTableRow;
